import React, { useState } from "react";
import { Modal, ModalBody, } from "reactstrap";
import certificate from "../../../../assets/img/brand/Digital_Health_Network.png";
import ModalHeader from "@dhn/components/molecules/modal-header";

const HIPAA_SEAL_IMAGE =
  "https://compliancy-group.com/wp-content/uploads/2022/10/HIPAA-Seal-of-Compliance-Hi-res.png";

export default function HipaaCertificateButton({
  className = "",
  imageClassName = "",
  width = 100,
  height = 50,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((currentValue) => !currentValue);

  return (
    <>
      <button
        type="button"
        className={`hipaa-certificate-button ${className}`.trim()}
        onClick={toggle}
        aria-label="Ver certificación HIPAA"
      >
        <img
          className={imageClassName}
          src={HIPAA_SEAL_IMAGE}
          alt="HIPAA Seal of Compliance"
          width={width}
          height={height}
        />
      </button>

      <Modal
        centered
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        className="hipaa-certificate-modal"
        contentClassName="hipaa-certificate-modal__content"
        backdropClassName="hipaa-certificate-modal__backdrop"
      >
        <ModalHeader
          toggle={toggle}
          iconClass="fa-certificate"
          description="Certificación HIPAA"
          subtitle="Consulte el certificado de cumplimiento HIPAA de la plataforma."
        />
        <ModalBody className="hipaa-certificate-modal__body">
          <img
            src={certificate}
            alt="Certificación HIPAA de Digital Health Network"
            className="hipaa-certificate-modal__image"
          />
        </ModalBody>
      </Modal>
    </>
  );
}
